import { Backdrop, CircularProgress } from "@material-ui/core";
import React from "react";

export default function Loading({ open = true }) {
    return (
        <Backdrop sx={{ color: "#fff" }} style={{ zIndex: 9999 }} open={open}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
